export default "__VITE_ASSET__ByPTejjh__"